import React from 'react';
import PropTypes from 'prop-types';

const WishlistIcon = ({ isSelected }) => {
  if (isSelected) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" role="img" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.8764 2.5C20.122 2.5 23.625 5.37156 23.625 10.0112C23.625 12.4037 22.3906 14.7745 19.8497 17.2586C18.1558 18.9165 15.9012 20.5855 13.1507 22.2187C12.84 22.4028 12.4862 22.5 12.125 22.5C11.7638 22.5 11.41 22.4028 11.0993 22.2187C8.34876 20.5855 6.09424 18.9165 4.39937 17.2582C1.85942 14.7745 0.625 12.4037 0.625 10.0112C0.625 5.37156 4.12797 2.5 7.37358 2.5C9.18636 2.5 10.8026 3.09524 12.125 4.23642C13.4474 3.09524 15.0636 2.5 16.8764 2.5Z" fill="#006FCF" />
      </svg>
    );
  }

  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" role="img" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M19.1755 16.1866L19.1761 16.1861C21.5675 13.848 22.5 11.8399 22.5 10.0112C22.5 6.18195 19.6507 4 17.2514 4C15.7877 4 14.522 4.47281 13.48 5.37203L12.5 6.21774L11.52 5.37203C10.478 4.47281 9.21226 4 7.74858 4C5.34932 4 2.5 6.18195 2.5 10.0112C2.5 11.84 3.43257 13.8481 5.8231 16.1857L5.8234 16.186C7.40907 17.7375 9.55908 19.337 12.2401 20.9289L11.4746 22.2181L12.2391 20.9283C12.3188 20.9755 12.4085 21 12.5 21C12.5913 21 12.6808 20.9756 12.7603 20.9286C15.4412 19.3368 17.591 17.7374 19.1755 16.1866ZM20.2247 17.2586C22.7656 14.7745 24 12.4037 24 10.0112C24 5.37156 20.497 2.5 17.2514 2.5C15.4386 2.5 13.8224 3.09524 12.5 4.23642C11.1776 3.09524 9.56136 2.5 7.74858 2.5C4.50297 2.5 1 5.37156 1 10.0112C1 12.4037 2.23442 14.7745 4.77437 17.2582C6.46924 18.9165 8.72376 20.5855 11.4743 22.2187C11.785 22.4028 12.1388 22.5 12.5 22.5C12.8612 22.5 13.215 22.4028 13.5257 22.2187C16.2762 20.5855 18.5308 18.9165 20.2247 17.2586Z" fill="#00175A" />
    </svg>
  );
};

WishlistIcon.propTypes = {
  isSelected: PropTypes.bool,
};

export default WishlistIcon;
